<template>
  <md-toolbar md-elevation="0"
    :class="['md-danger', { 'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute }]">
    <div :class="'md-toolbar-row'">
      <div :class="'md-toolbar-section-start'">
        <h3 :class="'md-title'">{{ $route.name }}</h3>
      </div>
      <div :class="'md-toolbar-section-end'">
        <md-button :class="['md-just-icon md-round md-simple md-toolbar-toggle', { toggled: $sidebar.showSidebar }]"
          @click="toggleSidebar">
          <span :class="'icon-bar'"></span>
          <span :class="'icon-bar'"></span>
          <span :class="'icon-bar'"></span>
        </md-button>
        <div :class="'md-collapse'">
          <md-list>
            <li :class="'md-list-item'">
              <a :class="'md-list-item-router md-list-item-container md-button-clean dropdown'">
                <div :class="'md-list-item-content'">
                  <span>{{ username }}</span>
                  <drop-down direction="down">
                    <md-button slot="title" :class="'md-button md-just-icon md-simple'" data-toggle="dropdown">
                      <span :class="'profile-label'">{{ userProfile }}</span>
                    </md-button>
                    <ul :class="'dropdown-menu dropdown-menu-right'">
                      <li v-if="isAdmin && onlyView" @click.prevent="changeProfile('admin')">
                        <a href="#">Admin</a>
                      </li>
                      <li v-if="onlyView" @click.prevent="changeProfile('engagement_leader')">
                        <a href="#">Engagement Leader</a>
                      </li>
                      <li v-if="onlyView" @click.prevent="changeProfile('manager')">
                        <a href="#">Manager of the Engagement</a>
                      </li>
                      <li v-if="onlyView" @click.prevent="changeProfile('reviewer')">
                        <a href="#">RQR Reviewer</a>
                      </li>
                      <li v-if="onlyView" @click.prevent="changeProfile('rqr_leader')">
                        <a href="#">RQR Leader</a>
                      </li>
                      <li v-if="isAdmin || isAdminTI" @click.prevent="changeProfile('adminTi')">
                        <a href="#">Admin TI</a>
                      </li>
                      <li v-if="isAdmin || isAudit" @click.prevent="changeProfile('audit')">
                        <a href="#">Auditor</a>
                      </li>
                    </ul>
                  </drop-down>
                  <drop-down direction="down">
                    <md-button slot="title" :class="'md-button md-just-icon md-simple'" data-toggle="dropdown">
                      <i :class="'material-icons'" :style="'color: white !important;'">person</i>
                      <p :class="'hidden-lg hidden-md'">Notifications</p>
                    </md-button>
                    <ul :class="'dropdown-menu dropdown-menu-right'">
                      <li @click.prevent="logout"><a href="#">Logout</a></li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>
          </md-list>
        </div>
      </div>
    </div>

  </md-toolbar>
</template>

<script>

export default {
  computed: {
    username() {
      return this.$store.state.user.name
    },
    userProfile() {
      return this.currentProfile !== 'user'
        ? this.currentProfile
        : 'engagement_leader'
    },
    currentProfile() {
      return this.$store.state.currentProfile
    },
    isAdmin() {
      return this.$store.state.profile === 'admin'
    },
    isAdminTI() {
      return this.$store.state.profile === 'adminTi'
    },
    isAudit() {
      return this.$store.state.profile === 'audit'
    },
    onlyView() {
      return this.$store.state.profile !== 'adminTi' && this.$store.state.profile !== 'audit'
    },
  },
  methods: {
    changeProfile(profile) {
      this.$store.commit('CURRENTPROFILE', profile)
    },
    logout() {
      this.$api.request.post("/logout").then(() => {
        sessionStorage.clear()
        localStorage.clear()
      }).catch(() => {
        this.$toast.error("Could not logout properly.")
      })
      this.$storage.clearStorage()
      this.$store.commit('ISUSERLOGGED', false)
      this.$store.commit('USERID', null)
      this.$store.commit('USERNAME', null)
      this.$store.commit('USERTOKEN', null)
      this.$store.commit('PROFILE', null)
      this.$store.commit('CURRENTPROFILE', null)
      this.$store.commit('REDIRECTO', null)
      
      window.location.href = "https://login-stg.pwc.com/openam/XUI/#logout/"
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    }
  }
}
</script>

<style>
.profile-label {
  padding: 0 1em;
  border-bottom: 1px solid rgba(255, 255, 255, .6);
  font-size: 12px;
  line-height: 2em;
  color: #fff;
}

.profile-label::after {
  content: '▼';
  margin-left: 1em;
  font-size: 0.8em;
}
</style>
